import { cloneExtendedSourceItem } from '../ExtendedSourceItem.js';
import { cloneFileItem } from '../FileItem.js';
// eslint-disable-next-line jsdoc/require-jsdoc
export function filterFileCollection(collection, predicate, newCollection) {
    const sourcesMap = new Map(collection.sources.map((s) => [s.uuid, s]));
    const filteredFiles = [];
    const filteredSources = new Map();
    for (const [index, file] of collection.files.entries()) {
        if (!predicate.call(collection.files, file, index, collection.files)) {
            continue;
        }
        filteredFiles.push(cloneFileItem(file));
        const source = sourcesMap.get(file.sourceUUID);
        if (!source)
            continue;
        if (filteredSources.has(file.sourceUUID))
            continue;
        filteredSources.set(file.sourceUUID, cloneExtendedSourceItem(source));
    }
    Object.assign(newCollection, {
        files: filteredFiles,
        sources: Array.from(filteredSources.values()),
    });
    return newCollection;
}
//# sourceMappingURL=filter_file_collection.js.map